'use client';

import { useState, useEffect } from 'react';

export default function ReceiptCounter({ className, style }: { className?: string; style?: React.CSSProperties }) {
  const [receiptsCount, setReceiptsCount] = useState(2677);

  useEffect(() => {
    const fetchCounter = async () => {
      try {
        const response = await fetch('/api/counter');
        const data = await response.json();
        setReceiptsCount(data.count);
      } catch (error) {
        console.error('Failed to fetch counter:', error);
      }
    };

    fetchCounter();
    const interval = setInterval(fetchCounter, 15000);
    return () => clearInterval(interval);
  }, []);

  return (
    <span className={className} style={style}>
      <strong className="font-bold text-[#1a1a2e]">{receiptsCount.toLocaleString()}</strong> Receipts created today.
    </span>
  );
}
